import { render } from "./skeleton-component.vue?vue&type=template&id=e0ff35dc&scoped=true"
import script from "./skeleton-component.vue?vue&type=script&lang=js"
export * from "./skeleton-component.vue?vue&type=script&lang=js"

import "./skeleton-component.vue?vue&type=style&index=0&id=e0ff35dc&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0ff35dc"]])

export default __exports__